import { Component, OnInit, Inject } from '@angular/core';
import { ErrorStateMatcher, DateAdapter, MAT_DATE_LOCALE } from '@angular/material/core';
import {MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormGroup, FormControl, FormGroupDirective, NgForm, Validators } from '@angular/forms';
import { ConfirmComponent } from '../../../shared/dialogs/confirm/confirm.component';
import { Document } from '../../../models/document';
import { SnackBarIconService } from '../../../shared/snack-bar-icon/snack-bar-icon.service';
import { DocumentService } from 'src/app/services/document.service';
import {FolderService} from 'src/app/services/folder.service';
import {Folder} from 'src/app/models/folder';


/** Error when invalid control is dirty, touched, or submitted. */
export class FormErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
  selector: 'app-member-document-dialog',
  templateUrl: './member-document-dialog.component.html',
  styleUrls: ['./member-document-dialog.component.scss'],
  entryComponents: [
    ConfirmComponent
  ],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'pt-BR' }
  ]
})
export class MemberDocumentDialogComponent implements OnInit {

  public matcher = new FormErrorStateMatcher(); // filter table
  public entityForm: FormGroup;   // store User Form
  public isEdit: boolean; // is insert or update
  public spinner: boolean = false;
  
  public folders: any = []
  public selectedFolder: any = {}

  public selectedDocFile: any = {};

  constructor(
    private fb: FormBuilder,
    private _documentService: DocumentService,
    private snackBar: SnackBarIconService,
    private _adapter: DateAdapter<any>,
    private _folderService: FolderService,
    public matDialogRef: MatDialogRef<MemberDocumentDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: Document
  ) { }


  ngOnInit() {

    this._adapter.setLocale('pt');

    // check is is insert or update
    if (this.data.id != "0") {
      this.isEdit = true;
    } else {
      this.isEdit = false
    }

    this.entityForm = this.createForm()
    this.setFormValues(this.data, this.entityForm)
    this.loadFolders()
  }

  createEntity(data: any): Document {

    let entity = new Document();

    entity.id = data.id;
    entity.filename = data.filename;
    entity.approved = data.approved;
    entity.date = data.date;
    entity.member_id = data.member_id;
    entity.member_name = data.member_name;
    entity.url = data.url;

    return entity;
  }

  setFormValues(data, form) {
    form.controls.id.setValue(data.id);
    form.controls.filename.setValue(data.filename);
    form.controls.approved.setValue(data.approved);
    form.controls.date.setValue(data.date);
    form.controls.folder_id.setValue(data.folder_id);
  }

  createForm() {
    let form: FormGroup = this.fb.group({
      id: new FormControl(''),
      filename: new FormControl('', [Validators.required]),
      approved: new FormControl('', [Validators.required]),
      date: new FormControl('', [Validators.required]),
      folder_id: new FormControl(''),

    });
    return form
  }

  loadFolders () {

    this._folderService.select()
      .subscribe((result) => {
        this.folders = []
        result.forEach((item) => {
          let entity = new Folder();
          entity.id = item.payload.doc.id;
          entity.name = item.payload.doc.data().name

          this.folders.push(entity)
        })
      })
  }

  selectFolder (folder_id) {
    this.selectedFolder = this.folders.find((e) => {
      return e.id === folder_id
    })
    console.log(JSON.stringify(this.selectedFolder))
  }

  previewDoc (event) {
    this.selectedDocFile = event.target.files[ 0 ]
    //console.log("this.selectedDocFile.filename: " + JSON.stringify(this.selectedDocFile))
    this.entityForm.controls.filename.setValue(this.selectedDocFile.name);
  }


}
